<ion-content>
  <div>
    <ion-spinner name="lines"></ion-spinner>
  </div>
</ion-content>
